import {autorun, action, observable } from 'mobx';
import {materializeValues} from '../utils';
import urlParse from 'url-parse';
import translateBase from '../translate';
let translate = translateBase.bindComponent('commonPersonalData');


export class VUserRegistration {
  constructor(flasher, api, navigation, masterData, authentication, personalData, rentalTransaction, 
    personalDataForm, personalAddressForms) {
    this.flasher = flasher;
    this.api = api;
    this.navigation = navigation;
    this.masterData = masterData;
    this.authentication = authentication;
    this.personalData = personalData;
    this.personalDataForm = personalDataForm;
    this.personalAddressForms = personalAddressForms;
  }

  @observable agbChecked = true;
  @observable message;
  
  @action.bound handleAGBClick(event) {
    this.agbChecked = event.target.checked;
  }  

  @observable usingPostAsBilling = true;
  
  @action.bound usePostAsBilling() {
    this.usingPostAsBilling = !this.usingPostAsBilling;
    if(this.usingPostAsBilling) {
      this.personalAddressForms[1].reset();
    }
  }  

  @action.bound interpretLink(link) { 
    const url = urlParse(link, true);
    if(url.hash === '#/confirmemail') {
      this.navigation.goUserRegistration3({
        token: url.query.token,
        userId: url.query.userId,
      });
    }
  }

  async registerUser({orgId}) {
    try{
      this.personalDataForm.setPurpose(this.personalDataForm.PURPOSES.REGISTRATION);
      this.personalDataForm.readOnlyAll = false;
      this.personalDataForm.visitAll();
      if(!this.personalDataForm.allValid) {
        throw new Error(translate("errInvalidFields", "Some of the form fields are not valid."));
      }

      this.personalAddressForms[0].visitAll();
      if(!this.usingPostAsBilling) {
        this.personalAddressForms[1].visitAll();
      }
      if(!this.personalAddressForms[0].allValid) {
        throw new Error(translate("errInvalidFields", "Some of the form fields are not valid."));
      }      
      if(!this.usingPostAsBilling && !this.personalAddressForms[1].allValid) {
        throw new Error(translate("errInvalidFields", "Some of the form fields are not valid."));
      }        


      await this.personalData.create({
        organizationId: orgId,
        userDetails: materializeValues(this.personalDataForm.values),
        addresses: this.personalAddressForms.map(paf => paf.isDirty ? materializeValues(paf.values) : null),
      });
    }
    catch(e) {
      //this.flasher.handleError(e);
      throw e
    }
    finally {
      this.flasher.setOther();
    }
  }

  @action.bound async createNewLessee() {
    try{
      this.flasher.setOther('Loading.');
      await this.registerUser({
        orgId: this.orgId
      });
      this.navigation.goUserRegistration2(); 
    }
    catch(e) {
      this.flasher.handleError(e);
    }
    finally {
      this.flasher.setOther();
    }
  }

  @action.bound async confirmRegistration() {
    try{
      this.flasher.setOther('Loading.');
      const message = await this.personalData.confirm({
        userId: this.userId,
        token: this.token,
      });
      this.navigation.goUserRegistration4({message});
    }
    catch(e) {
      this.flasher.handleError(e);
      //throw e;
    }
    finally {
      this.flasher.setOther(); 
    }    
  }

  async startOrUpdate({orgId, userId, token, step, message, code}) {
    this.personalDataForm.readOnlyAll = false;
    this.personalDataForm.setPurpose(this.personalDataForm.PURPOSES.REGISTRATION);
    this.orgId = orgId;
    this.userId = userId;
    this.token = token;
    this.message = message;
    switch(step) {
      case "1": 
        //this.personalDataForm.reset();
        //this.personalAddressForms.forEach(o => o.reset());
        try{
          this.flasher.setOther('Loading.');
          await this.masterData.fetch()
          this.arGoProfile = autorun(() => {
            if(this.authentication.loggedIn) {
              this.navigation.goUserProfile();
            }
          });  
        }
        catch(e) {
          this.flasher.handleError(e);
        }
        finally {
          this.flasher.setOther();
        }
        break;
      case "3":
        this.orgId = (await this.api.getIdByReferenceCode({code})).Id;
        window.sessionStorage.setItem('orgId', this.orgId); 
        await this.confirmRegistration();
        break;
    }

    /*  
    this.personalDataForm.init({
      salutation: this.personalData.salutation,
      firstName: this.personalData.firstName,
      lastName: this.personalData.lastName,
      email: this.personalData.email,
      phone: this.personalData.phone,      
      mobilePhone:  this.personalData.mobilePhone,
      faxPhone:  this.personalData.faxPhone,
      timeZone:  this.personalData.timeZone,
      language:  this.personalData.language,      
    });
    this.personalAddressForms.forEach(o => {
      const address = this.personalData.addresses[o.refAddressTypeId] || {};
      o.init({
        street: address.street,
        addition: address.addition,
        postalCode: address.postalCode,
        city: address.city,
        country: address.country,
      })
    });
    */
  }
  
  async stop() {
    this.arGoProfile && this.arGoProfile();
  }
}


// WEBPACK FOOTER //
// ./src/view/VUserRegistration.js